import { LogoutConfirmDialog } from "#app/components/auth/logout-confirm-dialog";
import { createDialogEmitter } from "#app/lib/dialog-emitter";

// The confirmation is opened from the ⌥⇧Q hotkey registered in the workspace
// layout, whose keydown handler runs outside any React subtree. The menus that
// offer "Log out" (account menu, settings sidebar) keep their own
// LogoutConfirmDialog instances: the account menu also renders on the
// workspace-select screen, where this mount does not exist.
const logoutConfirmDialog = createDialogEmitter("logout_confirm");

/** Open the log-out confirmation. Module-level so a keydown handler can call
 *  it without a hook. */
export function openLogoutConfirmDialog(): void {
  logoutConfirmDialog.open();
}

/** Mounts the confirmation once, in the workspace layout beside the other
 *  emitter-driven overlays. */
export function LogoutConfirmDialogMount() {
  const { open, setOpen } = logoutConfirmDialog.useDialogState();
  return <LogoutConfirmDialog onOpenChange={setOpen} open={open} via="hotkey" />;
}
